// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ELE1","rootNoMargin":"styles_rootNoMargin__1otKG"};